<template>
  <div>
    <b-form-group label="Conselho:">
      <SelectConselho
        v-model="mesa_diretora.conselho_id"
        :mandato_id="mesa_diretora.mandato_id"
        :state="validateState('conselho_id')"
      ></SelectConselho>
      <b-form-invalid-feedback :state="validateState('conselho_id')"
        >Conselho é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Mandatos:">
      <SelectMandatos
        v-model="mesa_diretora.mandato_id"
        :conselho_id="mesa_diretora.conselho_id"
        ref="SelectMandatos"
        tipo_mandato="mesa-diretora"
        :state="validateState('mandato_id')"
        @selected="
          (v) => {
            mesa_diretora.mandato = v;
          }
        "
      />
      <b-form-invalid-feedback :state="validateState('mandato_id')">
        Mandato é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Atribuições:">
      <ck-editor
        v-model="mesa_diretora.atribuicoes"
        placeholder="Atribuições"
      />
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";

import SelectConselho from "@/modules/conselhos/Components/SelectConselho";
import SelectMandatos from "@/modules/conselheiros/Components/SelectMandatos.vue";
import DateInput from "@/components/Form/DateInput";
import CkEditor from "@/components/Form/Editor.vue";

export default {
  components: { SelectConselho, DateInput, SelectMandatos, CkEditor },
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    mesa_diretora: {
      conselho_id: {
        required,
      },
      mandato_id: {
        required,
      },
      atribuicoes: {},
    },
  },
  computed: {
    ...mapState("mesas_diretoras", ["mesa_diretora"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.mesa_diretora[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.mesa_diretora.$touch();
      return !this.$v.mesa_diretora.$anyError;
    },
  },
  created() {},
};
</script>
